import { consumer, IResponse } from "@bemap/utils";

export const getPartnerDashboard = async (): Promise<IResponse> => {
  let url = `/reports/partner-dashboard`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}